import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { DataService } from "../../core/data.service";
import { AppConfigService } from 'src/app/core/app-config.service';
import { ConfigurationCategory } from '../models/configuration-category';

@Injectable({
  providedIn: "root",
})
export class ConfigurationCategoryDataService extends DataService<ConfigurationCategory> {
  constructor(http: HttpClient, acs: AppConfigService) {
    super(http, "ConfigurationCategories", acs);
  }  
}
